import {
  useFetchCollCalcTenants,
  useFetchDatamart2Tenants,
  useFetchDatamartTenants,
  useFetchLegalEntityTenants,
  useFetchLifeTenants,
  useFetchMoneyInTenants,
  useFetchMoneyOutTenants,
  useFetchUnitlinkTenants,
} from '@festina-life/api'
import { useAuthenticationContext } from '@festina-life/authentication'
import type { Optional } from '@festina-life/core'

import { useGetAvailableTenants } from './useGetAvailableTenants'
import { useIsComponentAvailable } from './useIsComponentAvailable'

export const useLifeTenants = () =>
  useGetAvailableTenants({
    component: 'life',
    useFetchTenants: useFetchLifeTenants,
  })

export const useDatamartTenants = () =>
  useGetAvailableTenants({
    component: 'dataMart',
    useFetchTenants: useFetchDatamartTenants,
  })

export const useDatamart2Tenants = () =>
  useGetAvailableTenants({
    component: 'dataMart2',
    useFetchTenants: useFetchDatamart2Tenants,
  })

export const useLegalEntityTenants = () =>
  useGetAvailableTenants({
    component: 'legalEntity',
    useFetchTenants: useFetchLegalEntityTenants,
  })

export const useUnitLinkTenants = () =>
  useGetAvailableTenants({
    component: 'unitLink',
    useFetchTenants: useFetchUnitlinkTenants,
  })

export const useMoneyOutTenants = () =>
  useGetAvailableTenants({
    component: 'moneyOut',
    useFetchTenants: useFetchMoneyOutTenants,
  })

export const useMoneyInTenants = () =>
  useGetAvailableTenants({
    component: 'moneyIn',
    useFetchTenants: useFetchMoneyInTenants,
  })

export const useCollCalcTenants = () =>
  useGetAvailableTenants({
    component: 'collCalc',
    useFetchTenants: useFetchCollCalcTenants,
  })

export const useAvailableComponentsForTenant = (
  forTenantId?: Optional<string>,
) => {
  const { environmentSettings } = useAuthenticationContext()

  return {
    isUsingLegalEntity: useIsComponentAvailable({
      component: 'legalEntity',
      availableTenants: useLegalEntityTenants(),
      forTenantId,
    }),
    isUsingLegalEntityDataReplicator:
      !!environmentSettings?.REACT_APP_LEGALENTITYDATAREPLICATOR_API_ENDPOINT,
    isUsingUnitLink: useIsComponentAvailable({
      component: 'unitLink',
      availableTenants: useUnitLinkTenants(),
      forTenantId,
    }),
    isUsingUnitLinkDataReplicator:
      !!environmentSettings?.REACT_APP_UNITLINKDATAREPLICATOR_API_ENDPOINT,
    isUsingMoneyOut: useIsComponentAvailable({
      component: 'moneyOut',
      availableTenants: useMoneyOutTenants(),
      forTenantId,
    }),
    isUsingMoneyIn: useIsComponentAvailable({
      component: 'moneyIn',
      availableTenants: useMoneyInTenants(),
      forTenantId,
    }),
    isUsingMoneyInTest:
      !!environmentSettings?.REACT_APP_MONEYINTEST_API_ENDPOINT,
    isUsingCollCalc: useIsComponentAvailable({
      component: 'collCalc',
      availableTenants: useCollCalcTenants(),
      forTenantId,
    }),
    isUsingLife: useIsComponentAvailable({
      component: 'life',
      availableTenants: useLifeTenants(),
      forTenantId,
    }),
    isUsingLifeDataReplicator:
      !!environmentSettings?.REACT_APP_LIFEDATAREPLICATOR_API_ENDPOINT,
    isUsingDatamart: useIsComponentAvailable({
      component: 'dataMart',
      availableTenants: useDatamartTenants(),
      forTenantId,
    }),
    isUsingDatamart2: useIsComponentAvailable({
      component: 'dataMart2',
      availableTenants: useDatamart2Tenants(),
      forTenantId,
    }),
  }
}
